import { ADD_CATEGORY, EDIT_CATEGORY } from './ApiConstants';
import api from './ApiHandler';

export interface CategoryRequest {
  page: number;
  limit: number;
  sortDirection?: number;
  sortBy?: string;
}

// export const getCategoriesByPage = async (payload: CategoryRequest) => {
//   return await api.get(GET_PRODUCT, { params: { ...payload } });
// };

export const createCategory = async (payload: any) => {
  return await api.post(ADD_CATEGORY, { ...payload });
};

export const editCategory = async (payload: any) => {
  return await api.post(EDIT_CATEGORY, { ...payload });
};
